import React from "react";
import { TYPE_META, assetUrl } from "./resourceUtils";

export const ResourceThumb = ({ r, className = "" }) => {
    const meta = TYPE_META[r.type] || TYPE_META.link;
    const src = assetUrl(r.thumbnail_url);
    if (src) {
        return (
            <img
                src={src}
                alt={r.thumbnail_alt || ""}
                loading="lazy"
                className={`w-full h-full object-cover ${className}`}
                data-testid={`resource-thumb-img-${r.id}`}
            />
        );
    }
    const { Icon } = meta;
    return (
        <div
            aria-hidden
            className={`w-full h-full flex items-center justify-center ${className}`}
            style={{ background: meta.tint }}
            data-testid={`resource-thumb-default-${r.id}`}
        >
            <Icon size={34} strokeWidth={1.1} style={{ color: "#5E6748" }} />
        </div>
    );
};
